import { store } from "../store/store";
import checkMultiplePayment from "./checkMultiplePayments";

let socket = null;
let maxAttempts = 10;
let currentAttempt = 0;

export function connectWebSocket() {
  return new Promise((resolve, reject) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      console.log("WebSocket connection already open");
      return resolve(socket);
    }
    if (socket && socket.readyState === WebSocket.CONNECTING) {
      console.log("WebSocket already connecting, waiting...");
      socket.addEventListener("open", () => resolve(socket), { once: true });
      socket.addEventListener("error", reject, { once: true });
      return;
    }
    socket = new WebSocket(process.env.VUE_APP_WSURL);
    socket.onopen = () => {
      console.log("WebSocket connection opened");
      currentAttempt = 0;
      resolve(socket);
    };
    socket.onclose = () => {
      console.log("WebSocket connection closed");
      if (currentAttempt < maxAttempts) {
        currentAttempt++;
        setTimeout(() => {
          connectWebSocket().catch(err =>
            console.error("Reconnect failed:", err)
          );
        }, 5000);
      } else {
        console.log("Maximum reconnection attempts reached");
      }
    };
    socket.onerror = (error) => {
      console.error("WebSocket error:", error);
      if (currentAttempt < maxAttempts) {
        currentAttempt++;
        setTimeout(() => {
          connectWebSocket().catch(err =>
            console.error("Reconnect failed:", err)
          );
        }, 5000);
      } else {
        console.log("Maximum reconnection attempts reached");
      }
      reject(error);
    };
    socket.onmessage = async (event) => {
      let data = JSON.parse(event.data)[0];
      const pedidos = store.getters.pedidos;
      const count = JSON.parse(event.data)[1];
      data.map((val) => !val.statusPgto ? val.statusPgto = 'PEN' : '');

      for (let pedido of pedidos) {
        for (let pedidoApi of data) {
          if (pedidoApi.num == pedido.num) {
            pedidoApi.statusPgto = pedido.statusPgto ? pedido.statusPgto : 'PEN';
          }
        }
      }
      store.commit("incrementCount", count);
      console.log(data);
      store.commit("incrementPedidos", data);
    };
  });
}

setInterval(() => {
  check();
}, 15000);

async function check() {
  let pedidos = [];
  let empresa = [];
  let maxBatchSize = 29;
  const sitef = store.getters.dadosEmpresa.sitef;
  let data = store.getters.pedidos;
  data.map((val) => !val.statusPgto ? val.statusPgto = 'PEN' : '');
  for (let [index, pedido] of data.entries()) {
    if (!pedido.ambientePgto) {
      pedido.ambientePgto = 'Pagar na entrega/retirada';
    }
    if (
      pedido.status != 'geroucupom' &&
      pedido.status != 'naoenviado' &&
      pedido.status != 'pdf' &&
      pedido.status != 'concluido' &&
      pedido.ambientePgto == 'Pagar no app' &&
      pedido.statusPgto != 'CON'
    ) {
      empresa = empresa != "" ? empresa : pedido.empresa;
      pedidos.push(pedido.num.toString());
      if (pedidos.length === maxBatchSize && pedidos != '') {
        await checkMultiplePayment(empresa, pedidos, sitef).then((val) => {
          if (val.data.data) {
            for (let pedido of val.data.data) {
              data.find((val) => val.num == pedido.order_id).statusPgto =
                pedido.payment ? pedido.payment.status : 'Não encontrado';
            }
          }
        });
        store.commit("incrementCarregando", false);
        pedidos = [];
      }
    }
    if (index === data.length - 1 && pedidos != '') {
      await checkMultiplePayment(empresa, pedidos, sitef).then((val) => {
        if (val.data.data) {
          for (let pedido of val.data.data) {
            data.find((val) => val.num == pedido.order_id).statusPgto =
              pedido.payment ? pedido.payment.status : 'Não encontrado';
          }
        }
      });
      store.commit("incrementCarregando", false);
      pedidos = [];
    }
  }
  store.commit("incrementPagamentos", data);
}

connectWebSocket().catch(err => console.error("Initial WS connection failed:", err));